// extracted by mini-css-extract-plugin
export default {"wrap":"Tabs_wrap__pX8T4","tab":"Tabs_tab__2LlEs","active":"Tabs_active__kpq1D","indicator":"Tabs_indicator__MK1fp","label":"Tabs_label__Ufvc+"};